module.exports = __webpack_public_path__ + "img/eurada-belgium.4096c05d.png";